import React, { useContext, useEffect, useState } from 'react'
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import logo from '../../assets/biztrade_logo/logo.png'
import { Auth } from '../../contexts/allContext'
import { apiV1 } from '../../utils/api'
import classes from './Login.module.css'

export default function Login() {
    const { stateAuth, dispatchAuth } = useContext(Auth)
    const navigate = useNavigate()
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [alertSubmit, setAlertSubmit] = useState(false)
    const [radio, setRadio] = useState('')
    const [showPassword, setShowPassword] = useState(false)

    const handleSubmit = async (e) => {
        e.preventDefault()
        const details = {
            identifier: email,
            password: password,
        }

        try {
            const url = radio === 'loggedin' ? `${apiV1}/login/in` : `${apiV1}/login/`
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(details),
            })

            const log = await response.json()

            if (response.ok) {
                dispatchAuth({ type: 'token', payload: log.access_token })
                toast.success('Login successful!', {
                    position: 'top-center',
                    style: { textAlign: 'center' },
                })
                setTimeout(() => {
                    navigate('/dashboard')
                }, 1000)
            } else {
                toast.error('Login failed: Incorrect email or password.', {
                    position: 'top-center',
                })

                setAlertSubmit(true)
                setTimeout(() => {
                    setAlertSubmit(false)
                }, 3000)
            }
        } catch (error) {
            toast.error('Something went wrong. Please try again.')
        }
    }

    useEffect(() => {
        if (stateAuth.auth) {
            navigate('/dashboard')
        }
    }, [navigate, stateAuth])

    return (
        <div className={classes.wrapper}>
            <div className={classes.wrapperInner}>
                <form className={classes.formBox} onSubmit={handleSubmit}>
                    <div className={classes.logoContainer}>
                        <img src={logo} alt="logo" />
                        <p className={classes.headingLine}>Welcome To Buyer Dashboard</p>
                    </div>
                    {/* Main SIGN IN Focal Text */}
                    <div className={classes.textContainer}>
                        <p className={classes.signInText}>SIGN IN</p>
                    </div>
                    {alertSubmit && <div className={classes.alertMessage}>Please enter valid user and password!</div>}
                    <div className={classes.inputValue}>
                        <input
                            type="email"
                            placeholder="Enter your email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div className={classes.inputValue}>
                        <input
                            type={showPassword ? 'text' : 'password'}
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                        <span
                            className={classes.passwordToggleIcon}
                            onClick={() => setShowPassword(!showPassword)}
                            aria-label="Toggle password visibility"
                            role="button"
                            tabIndex={0}>
                            {showPassword ? <FaEye /> : <FaEyeSlash />}
                        </span>
                    </div>

                    <div className={classes.keepLogin}>
                        <div className={classes.inputContainer}>
                            <label>
                                <input
                                    type="checkbox"
                                    name="loggedin"
                                    value="loggedin"
                                    onChange={() => setRadio(radio === 'loggedin' ? '' : 'loggedin')}
                                    checked={radio === 'loggedin'}
                                />
                                Keep me sign in
                            </label>
                        </div>
                        <p className={classes.forgotText}>
                            <a
                                href="/forgot-password"
                                className={classes.forgotText}
                                // target="_blank"
                                // rel="noopener noreferrer">
                            >
                                Forgot Password?
                            </a>
                        </p>
                    </div>
                    <button type="submit" className={classes.loginBtn}>
                        SIGN IN
                    </button>
                    <p className={classes.registerLink}>
                        Don't have account?
                        <a href="https://biztradebd.com/registration/buyer" style={{ textDecoration: 'none' }}>
                            <span> Register</span>
                        </a>{' '}
                    </p>
                </form>
            </div>
        </div>
    )
}
